import type { FaireProductEntity } from "../../entity_types/product";

export const p_be84b94p4k: FaireProductEntity = {
  token: "p_be84b94p4k",
  type: "product",
  name: "YOUTH Custom Split Colored, Two-Toned, YOUTH Crewneck",
  brandToken: "b_xff5jwej98",
  brandName: "McKenzie’s Infinity LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/81bdbf673a9e5aa5f39893b9a7465d1e899056290f7971ef74207ded596c92de.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b7bd56b81f7065bd8c7d372a6b09c4cb56df9e9ae8f9726de8fc66f27fc7865e.png",
  ],
  priceDollars: 22.75,
  description:
    "THESE ARE YOUTH SIZES!\n\nGet the best of both worlds with our Custom Split Colored, Two-Toned, Crewneck Sweatshirt! Stay cozy and trendy at the same time with this playful and stylish sweatshirt. Perfect for those who love to stand out and make a statement.\n\nPlease note: these crewnecks are hand cut and sewn, no two will look the same. This is a physical product. This product is unisex. This product is BLANK. Choice of color side is NOT available; crewneck colors will be on either the left or right. \n\nThis is a wholesale, cut-and-sew garment intended for resale or private labeling. Garments are not sold as retail-ready. Final consumer-facing labeling is the responsibility of the retailer prior to resale.\nGarment Details:\n8 oz./yd² (US), 13.3 oz./L yd (CA)\n50/50 cotton/polyester, 20 singles\nHeather Dark Green, Heather Dark Maroon, Heather Dark Navy, Heather Deep Royal, and Heather Scarlet Red are 60/40 polyester/cotton\nSafety Green is compliant with ANSI / ISEA 107 high-visibility standards\nClassic fit\n1x1 rib with spandex for enhanced stretch and recovery\nHandmade in the United States\n\nThis is a made-to-order custom item. Please review the description, including processing time, before purchasing. By ordering, you confirm you understand the turnaround time.\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:30.814Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
